export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10398.d717be9f.jpg";